const mobileToggle = document.getElementById('toggle-mobile-nav')

if ( mobileToggle ) {
    mobileToggle.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()
        document.body.classList.toggle("mob-nav-in-view")
    })
}
